<template>
    <div id="company">

        <Head></Head>

        <div v-show="selectVisible">
            <h3>选择公司</h3>
            <el-select v-model="value" placeholder="请选择公司" @change="selectCompany">
                <el-option v-for="item in companyList" :key="item.id" :label="item.companyName" :value="item.id">
                </el-option>
            </el-select>

            <el-divider content-position="center"><span style="color:green">或</span></el-divider>
            <el-button @click="createNew" type="danger" plain>创建新公司</el-button>
            <el-button @click="exit" type="danger" plain>退出系统</el-button>
        </div>

        <el-form ref="form" :model="form" label-width="80px" v-show="formVisible">
            <p></p>
            <el-form-item label="公司类型">
                <el-select v-model="form.companyType" placeholder="选择公司类型">
                    <el-option label="注塑加工" value="0"></el-option>

                    <el-option label="流水生产" value="1"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="公司名称">
                <el-input v-model="form.companyName"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="danger" @click="onSubmit">立即创建</el-button>
                <el-button @click="cancelCreate">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Head from "@/views/Head.vue";

export default {
    data() {
        return {
            token: this.getToken(),
            userId: this.getUserId(),

            companyList: [],
            value: '',

            selectVisible: true,
            formVisible: false,

            form: {
                companyType: null,
                companyName: ''
            }
        }
    },
    components: {
        Head
    },
    methods: {
        selectCompany(value) {

            this.$axios({
                method: "put",
                url: "/shiro/sys/token/modify",
                data: {
                    companyId: value,
                    userId: this.userId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.data != null) {
                    this.setToken(data.data)
                }

                this.setCompanyId(value)

                this.setPersonalCenter(0)

                this.$router.push({
                    path: "/home"
                })
            })

        },
        createNew() {
            this.selectVisible = false
            this.formVisible = true
        },
        cancelCreate() {
            this.formVisible = false
            this.selectVisible = true
        },
        onSubmit() {

            if (this.form.companyType == null) {

                this.$message({
                    type: 'info',
                    message: '请选择公司类型'
                })
            } else {
                this.$axios({
                    method: "post",
                    url: "/shiro/company/add",
                    data: {
                        companyType: this.form.companyType,
                        companyName: this.form.companyName,
                        userId: this.userId
                    }, headers: {
                        token: this.token
                    }
                }).then(result => {
                    //alert(result)

                    this.formVisible = false
                    this.selectVisible = true

                    this.getAllCompany()
                })
            }
        },
        getAllCompany() {
            this.$axios({
                method: "post",
                url: "/shiro/company/getAll",
                data: {
                    userId: this.userId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                //console.log(result.data)

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                this.companyList = data.data
            })
        },
        exit() {
            this.$axios({
                method: "POST",
                url: "/shiro/sys/logout",
                data: {},
                headers: {
                    token: this.token
                }
            }).then(result => {
                if (result.status === 200) {

                    const data = result.data

                    if (data.status === 200) {
                        this.$message({
                            showClose: true,
                            message: data.msg,
                            type: "success",
                            duration: "1600"
                        })
                    } else {
                        this.$message({
                            showClose: true,
                            message: data.msg,
                            type: "error",
                            duration: "3000"
                        })
                    }

                    this.setToken("")

                    this.$router.push({ path: "/Login" })
                } else {
                    this.$message({
                        showClose: true,
                        message: "操作失败，请联系管理员",
                        type: "error",
                        duration: "3000"
                    })
                }
            })
        }
    },
    mounted() {

        let url = window.location.href

        // console.log('url')
        // console.log(url)

        let str = url.substring(url.indexOf('?') + 1)
        let arrs = str.split('&')
        let result = {}

        arrs.forEach(item => {
            let keyArr = item.split('=')
            let name = keyArr[0];
            let value = keyArr[1];
            result[name] = value;
        })

        if (Object.keys(result).length > 1) {
            // console.log(result)
            // console.log('result.token')
            // console.log(result.token)

            this.setToken(result.token)

            // console.log('result.userId')
            // console.log(result.userId)

            this.setUserId(result.userId)
        }

        this.getAllCompany()
    }
}
</script>

<style>
#company {
    width: 500px;
    height: 200px;
    position: relative;
    margin: auto;
    padding-top: 100px;
    color: green;
}
</style>